"use client";

import React from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import "./PrivacyPolicyPopup.css";

export default function PrivacyPolicyPopup({ open, onClose }) {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("signup.privacyPolicyTitle")}
      open={open}
      onCancel={onClose}
      onOk={onClose}
      okText={t("commonn.close", { defaultValue: "Close" })}
      cancelButtonProps={{ style: { display: "none" } }}
      className="navbar-privacy-modal signup-privacy-modal"
      centered
      width={720}
      destroyOnClose
      getContainer={false}
    >
      <div className="privacy-text navbar-privacy-text">
        <p>{t("signup.privacy.intro")}</p>
        <p>{t("signup.privacy.paragraph1")}</p>

        <h4>{t("signup.privacy.section1Title")}</h4>
        <p>{t("signup.privacy.section1Text")}</p>
        <ul>
          <li>{t("signup.privacy.section1Item1")}</li>
          <li>{t("signup.privacy.section1Item2")}</li>
          <li>{t("signup.privacy.section1Item3")}</li>
          <li>{t("signup.privacy.section1Item4")}</li>
        </ul>
        <p>{t("signup.privacy.section1Conclusion")}</p>

        <h4>{t("signup.privacy.section2Title")}</h4>
        <ul>
          <li>{t("signup.privacy.section2Item1")}</li>
          <li>{t("signup.privacy.section2Item2")}</li>
          <li>{t("signup.privacy.section2Item3")}</li>
          <li>{t("signup.privacy.section2Item4")}</li>
          <li>{t("signup.privacy.section2Item5")}</li>
        </ul>

        <h4>{t("signup.privacy.section3Title")}</h4>
        <ul>
          <li>{t("signup.privacy.section3Item1")}</li>
          <li>{t("signup.privacy.section3Item2")}</li>
          <li>{t("signup.privacy.section3Item3")}</li>
        </ul>
        <p>{t("signup.privacy.section3Conclusion")}</p>

        <h4>{t("signup.privacy.section4Title")}</h4>
        <ul>
          <li>{t("signup.privacy.section4Item1")}</li>
          <li>{t("signup.privacy.section4Item2")}</li>
          <li>{t("signup.privacy.section4Item3")}</li>
        </ul>

        <h4>{t("signup.privacy.section5Title")}</h4>
        <ul>
          <li>{t("signup.privacy.section5Item1")}</li>
          <li>{t("signup.privacy.section5Item2")}</li>
        </ul>

        <h4>{t("signup.privacy.section6Title")}</h4>
        <p>
          {t("signup.privacy.section6Text")}<br />
          📧 <a href="mailto:support@mediwave.tn">support@mediwave.tn</a>
        </p>
      </div>
    </Modal>
  );
}
